import { HttpClientModule, provideHttpClient, withInterceptors } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { ToastrModule, provideToastr } from 'ngx-toastr';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatChipsModule } from '@angular/material/chips';
import { AppComponent } from './app.component';
import { HelperMethods } from './common/helper-methods.service';
import { LoaderComponent } from './common/loader/loader.component';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SidemenuComponent } from './sidemenu/sidemenu.component';
import { AccountAdminCenterComponent } from './account-admin-center/account-admin-center.component';
import { CommonModule } from '@angular/common';
import { AppRoutingModule, routes } from './app.routes';
import { RouterModule, provideRouter } from '@angular/router';
import { MSAL_INSTANCE, MsalModule, MsalService } from '@azure/msal-angular';
import { authInterceptor } from './interceptor/auth.interceptor';
import { loaderInterceptor } from './interceptor/loader.interceptor';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { BrowserCacheLocation, InteractionType, IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { environment } from '../app/environments/environment.development'
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { AuthGuard } from './auth/auth.guard';
import { JwtModule } from '@auth0/angular-jwt';
import { NgxMatIntlTelInputComponent } from 'ngx-mat-intl-tel-input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AccountAdminCenterService } from './account-admin-center/account-admin-center.service';
import { UserCenterComponent } from './user-center/user-center.component';
import { DataManagementComponent } from './data-management/data-management.component';
import { PackageComponent } from './package-center/package/package.component';
import { ModuleComponent } from './data-management/module/module.component';
import { SubCategoryComponent } from './data-management/sub-category/sub-category.component';
import { MetricsComponent } from './data-management/metrics/metrics.component';
import { CreateAccountAdminComponent } from './account-admin-center/create-account-admin/create-account-admin.component';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { ProdetailsModalComponent } from './data-management/prodetails-modal/prodetails-modal.component';
import { MatAccountComponent } from './mat-account/mat-account.component';
import { PackageCenterComponent } from './package-center/package-center.component';
import { EditAdminComponent } from './user-center/admin-details/edit-admin/edit-admin.component';
import { AdminDetailsComponent } from './user-center/admin-details/admin-details.component';
import { SwapPackageComponent } from './user-center/swap-package/swap-package.component';
import { PackageDetailsComponent } from './mat-admin/package-details/package-details.component';
import { NotificationsComponent } from './user-center/notifications/notifications.component';
import { DataAlertsComponent } from './user-center/notifications/data-alerts/data-alerts.component';
import { AddSchoolComponent } from './user-center/add-school/add-school.component';
import { MatTabsModule } from '@angular/material/tabs';
import {MatMenuModule} from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import {MatButtonModule} from '@angular/material/button';
import { CreateUserComponent } from './user-center/create-user/create-user.component';
import { UserDetailsComponent } from './user-center/create-user/user-details/user-details.component';
import { AddSchoolUserComponent } from './school/add-school-user/add-school-user.component';
import { SchoolBasicDetailsComponent } from './school/school-basic-details/school-basic-details.component';
import { UserRoleComponent } from './user-center/user-role/user-role.component';
import { EditUserRoleComponent } from './user-center/user-role/edit-user-role/edit-user-role.component';
import { ProfileComponent } from './profile/profile.component';
import { EditProfileDetailsComponent } from './profile/edit-profile-details/edit-profile-details.component';
import { SchoolDetailsComponent } from './school/school-details/school-details.component';
import { IndependentSchoolComponent } from './independent-school/independent-school.component';
import { SharedService } from '../shared/services/shared.service';
import { ThemeService } from '../shared/services/theme.service';
import { EdmartService } from '../shared/services/edmart.service';
import { CreateRoleComponent } from './user-center/create-role/create-role.component';
import { EditSchoolComponent } from './user-center/edit-school/edit-school.component';
import { IndependentEntityComponent } from './independent-entity/independent-entity.component';
import { CreateSchoolComponent } from './school/create-school/create-school.component';
import { SchoolListComponent } from './school/school-list/school-list.component';
import { SectorComponent } from './sector/sector.component';
import { CreateSectorComponent } from './sector/create-sector/create-sector.component';
import { EditSectorComponent } from './sector/edit-sector/edit-sector.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { PowerbiReportComponent } from './powerbi-report/powerbi-report.component';
import { EditAccountDetailsComponent } from './user-center/edit-account-details/edit-account-details.component';
import { TicketManagementComponent } from './ticket-management/ticket-management.component';
import { RaiseTicketComponent } from './ticket-management/raise-ticket/raise-ticket.component';
import { ViewTicketCommentsComponent } from './ticket-management/view-ticket-comments/view-ticket-comments.component';
import { AddTicketCommentsComponent } from './ticket-management/add-ticket-comments/add-ticket-comments.component';
import { ConfirmComponent } from '../shared/components/confirm/confirm.component';
import { ViewTicketDescriptionComponent } from './ticket-management/view-ticket-description/view-ticket-description.component';
import { UploadedFilesComponent } from './ticket-management/uploaded-files/uploaded-files.component';
import { ConfirmDialogComponent } from './mat-account/confirm-dialog/confirm-dialog.component';
import { TransferSchoolComponent } from './user-center/transfer-school/transfer-school.component';
import { SendBulkEmailComponent } from './mat-account/send-bulk-email/send-bulk-email.component';
import { RequestAccessComponent } from './school/request-access/request-access.component';
import { ErrorLogComponent } from './error-log/error-log.component';
import { TraceReportComponent } from './trace-report/trace-report.component';
import { SystemMessagesComponent } from './system-messages/system-messages.component';
import { OnepageComponent } from './onepage/onepage.component';
import { StudentComponent } from './education/student/student.component';
import { StudentDetailsComponent } from './education/student/student-details/student-details.component';
import { StudentInAPageComponent } from './education/student/student-in-apage/student-in-apage.component';
import { StudentTimeLineComponent } from './education/student/student-time-line/student-time-line.component';


import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatDividerModule } from '@angular/material/divider';
import { SaveReportViewComponent } from './dashboard/save-report-view/save-report-view.component';
import {MyInsightsComponent} from './dashboard/my-insights/my-insights.component';
import { MatListModule } from '@angular/material/list';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { StudentAiTimelineComponent } from './education/student/student-time-line/student-ai-timeline';


export function tokenGetter() {
  return sessionStorage.getItem('access_token');
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    LoaderComponent,
    SidemenuComponent,
    AccountAdminCenterComponent, 
    UserCenterComponent,
    DataManagementComponent,
    PackageComponent,
    ModuleComponent,
    SubCategoryComponent,
    MetricsComponent,
    CreateAccountAdminComponent,
    ProdetailsModalComponent,
    MatAccountComponent,
    PackageCenterComponent,
    EditAdminComponent,
    AdminDetailsComponent,
    SwapPackageComponent,
    PackageDetailsComponent,
    NotificationsComponent,
    DataAlertsComponent,
    AddSchoolComponent,
    CreateUserComponent,
    UserDetailsComponent,
    AddSchoolUserComponent,
    SchoolBasicDetailsComponent,
    UserRoleComponent,
    EditUserRoleComponent,
    ProfileComponent,
    EditProfileDetailsComponent,
    SchoolDetailsComponent,
    IndependentSchoolComponent,
    CreateRoleComponent,
    EditSchoolComponent,
    IndependentEntityComponent,
    CreateSchoolComponent,
    SchoolListComponent,
    SectorComponent,
    CreateSectorComponent,
    EditSectorComponent,
    DashboardComponent,
    PowerbiReportComponent,
    EditAccountDetailsComponent,
    TicketManagementComponent,
    RaiseTicketComponent,
    ViewTicketCommentsComponent,
    ViewTicketDescriptionComponent,
    AddTicketCommentsComponent,
    ConfirmComponent,
    UploadedFilesComponent,
    ConfirmDialogComponent,
    TransferSchoolComponent,
    SendBulkEmailComponent,
    RequestAccessComponent,
    ErrorLogComponent,
    TraceReportComponent,
    SystemMessagesComponent,
    SaveReportViewComponent,
    MyInsightsComponent,
    OnepageComponent,
    StudentComponent,
    StudentDetailsComponent,
    StudentInAPageComponent,
    StudentTimeLineComponent
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    AppRoutingModule,
    MatRadioModule,
    MatListModule,
    MatButtonToggleModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    ToastrModule.forRoot({
        progressBar: true,
        maxOpened: 1,
        preventDuplicates: true,
    }),
    MatSnackBarModule,
    MatPaginatorModule,
    MatIconModule,
    MatDividerModule,
    MatChipsModule,
    JwtModule.forRoot({
        config: {
            tokenGetter: tokenGetter,
            allowedDomains: [environment.BackendDomain],
            disallowedRoutes: []
        }
    }),
    NgxMatIntlTelInputComponent,
    MatTooltipModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    MatTabsModule,
    MatButtonModule,
    MatMenuModule,
    MatToolbarModule,
    MsalModule.forRoot(MSALInstanceFactory(), {
        interactionType: InteractionType.Redirect,
        authRequest: {
            scopes: ['https://analysis.windows.net/powerbi/api/.default']
        }
    }, {
        interactionType: InteractionType.Redirect,
        protectedResourceMap: new Map([
            ['https://api.powerbi.com/', ['https://analysis.windows.net/powerbi/api/.default']]
        ])
    }),
    MatSlideToggle,
    MatAutocompleteModule,
    StudentAiTimelineComponent
],
  providers: [
    AuthGuard,
    provideHttpClient(
      withInterceptors(
        [authInterceptor, loaderInterceptor]
      )
    ),
    { provide: MatDialogRef, useValue: {} },
    { provide: MAT_DIALOG_DATA, useValue: {} },
    provideRouter(routes),
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    MsalService,
    HttpClientModule,
    AccountAdminCenterService,
    provideHttpClient(),
    RouterModule,
    HelperMethods,
    provideToastr({
      closeButton: true,
      positionClass: 'toast-top-center',
      timeOut: 10000
    }),
    provideAnimations(),
    MatProgressSpinnerModule,
    MatProgressBarModule,
    provideAnimationsAsync(),
    MatPaginatorModule,
    MatIconModule,
    MatTabsModule,
    SharedService,
    ThemeService,
    EdmartService
  ],
  exports: [
    AppComponent,
    LoginComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    LoaderComponent,
    SidemenuComponent,
    AccountAdminCenterComponent, 
    UserCenterComponent,
    DataManagementComponent,
    PackageComponent,
    ModuleComponent, 
    SubCategoryComponent,
    MetricsComponent,
    CreateAccountAdminComponent,
    ProdetailsModalComponent,
    MatAccountComponent,
    PackageCenterComponent,
    EditAdminComponent,
    AdminDetailsComponent,
    SwapPackageComponent,
    PackageDetailsComponent,
    NotificationsComponent,
    AddSchoolComponent,
    CreateUserComponent,
    UserDetailsComponent,
    AddSchoolUserComponent,
    SchoolBasicDetailsComponent,
    UserRoleComponent,
    EditUserRoleComponent,
    ProfileComponent,
    EditProfileDetailsComponent,
    SchoolDetailsComponent,
    IndependentSchoolComponent,
    EditSchoolComponent,
    IndependentEntityComponent,
    CreateSchoolComponent,
    SchoolListComponent,
    SectorComponent,
    CreateSectorComponent,
    EditSectorComponent,
    DashboardComponent,
    PowerbiReportComponent,
    EditAccountDetailsComponent,
    TicketManagementComponent,
    RaiseTicketComponent,
    ViewTicketCommentsComponent,
    ViewTicketDescriptionComponent,
    AddTicketCommentsComponent,
    ConfirmComponent,
    UploadedFilesComponent,
    TransferSchoolComponent,
    SendBulkEmailComponent,
    RequestAccessComponent,
    ErrorLogComponent,
    TraceReportComponent,
    SystemMessagesComponent,
    SaveReportViewComponent,
    MyInsightsComponent,
    OnepageComponent,
    StudentComponent,
    StudentDetailsComponent,
    StudentInAPageComponent,
    StudentTimeLineComponent
  ],
  bootstrap: [AppComponent],
})


export class AppModule {

}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: environment.azure,
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: false
    },
    system: {
      allowNativeBroker: false
    }
  });
}
